import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { ArrowBtn } from "../../../../app-constants";

function Servicelisting(props) {
  return (
    <section className="p-100 pt-0">
      <Container>
        <>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="seriveces_listing page_listing"
            >
              <div className="example" data-text="Products">
                <h2>Products</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>CMS</h4>
                <p>
                  TekRevol is capable of providing tailored CMS solutions that
                  integrate a user-friendly interface and advanced features
                </p>
                <Link to="https://www.tekrevol.com/cms-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>HRM</h4>
                <p>
                  Build a custom HRM solution for your business and skyrocket
                  your teams’ workflows.
                </p>
                <Link to="/solution/hrm-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>CRM</h4>
                <p>
                  Work with the best CRM development company for development,
                  execution, migration and support
                </p>
                <Link to="https://www.tekrevol.com/solution/crm-developers">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>ERP</h4>
                <p>
                  TekRevol provides ERP software development services that offer
                  end-to-end ERP development
                </p>
                <Link to="/solution/erp-developers">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>LMS</h4>
                <p>
                  Acquire your easy-to-use, custom, and scalable learning
                  management solution that offers exceptional learning
                  experiences
                </p>
                <Link to="https://www.tekrevol.com/solution/custom-lms-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>POS</h4>
                <p>
                  We are a POS development company specializing in creating
                  tailored product solutions
                </p>
                <Link to="/solution/pos-development">{ArrowBtn}</Link>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="seriveces_listing page_listing"
            >
              <div className="example" data-text="Industries">
                <h2>Industries</h2>
              </div>
            </Col>

            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Healthcare Solution</h4>
                <p>
                  Transform your healthcare business with TekRevol's customized
                  healthcare solutions
                </p>
                <Link to="/solution/healthcare-solution">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Healthcare App Development</h4>
                <p>
                  Comprehensive healthcare app development services with a
                  sustainable and scalable approach
                </p>
                <Link to="https://www.tekrevol.com/healthcare-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Educational</h4>
                <p>
                  TekRevol builds custom learning management software for
                  enterprises and institutions
                </p>
                <Link to="/solution/educational-software-company">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Fintech</h4>
                <p>
                  TekRevol is a custom Fintech software development company that
                  builds digital banking and investment applications
                </p>
                <Link to="/fintech-software-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Logistics</h4>
                <p>
                  TekRevol creates logistic software for businesses to manage
                  warehousing, storage, and streamline logistic operations
                </p>
                <Link to="/solution/logistics-software-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Retail</h4>
                <p>
                  TekRevol offers advanced retail software solutions to improve
                  user experience and increase sales
                </p>
                <Link to="/solution/retail-software-solution">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Ecommerce</h4>
                <p>
                  Gain 10X conversions through digitalizing your businesses with
                  our custom Ecommerce application development
                </p>
                <Link to="https://www.tekrevol.com/solution/ecommerce-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>IT staff augmentation</h4>
                <p>
                  Ensure Your Project's Success Through Our IT Staff
                  Augmentation Services
                </p>
                <Link to="https://www.tekrevol.com/solution/it-staff-augmentation">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Music</h4>
                <p>
                  Tekrevol is a prime music app development company, helping
                  clients worldwide
                </p>
                <Link to="https://www.tekrevol.com/solution/music-app-developers">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>On-demand</h4>
                <p>
                  Tekrevol is an expert on-demand delivery app development
                  company that has served multiple startups and entrepreneurs
                </p>
                <Link to="https://www.tekrevol.com/on-demand-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Automotive</h4>
                <p>
                  From car leasing service providers to auto e-commerce
                  inventory solutions, leverage our readily available platforms
                </p>
                <Link to="/solution/automotive-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Real Estate</h4>
                <p>
                  We are a full-scale real estate app development company that
                  helps real estate companies to build custom real estate apps.
                </p>
                <Link to="/solution/real-estate-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Hire Android App Developers</h4>
                <p>
                  Are you looking to hire Android developers to bring your app
                  vision to life? Your search ends here!.
                </p>
                <Link to="/hire-android-app-developers">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Telemedicine App Development</h4>
                <p>
                  As the line between healthcare and technology thins, our
                  telemedicine app development company.
                </p>
                <Link to="/telemedicine-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
          </Row>
        </>
      </Container>
    </section>
  );
}

export default Servicelisting;
